var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35506 2.948V7H3.64306V2.948H4.35506ZM4.50706 1.676C4.50706 1.74533 4.4924 1.81067 4.46306 1.872C4.4364 1.93067 4.39906 1.984 4.35106 2.032C4.30573 2.07733 4.25106 2.11333 4.18706 2.14C4.12573 2.16667 4.0604 2.18 3.99106 2.18C3.92173 2.18 3.8564 2.16667 3.79506 2.14C3.7364 2.11333 3.6844 2.07733 3.63906 2.032C3.59373 1.984 3.55773 1.93067 3.53106 1.872C3.5044 1.81067 3.49106 1.74533 3.49106 1.676C3.49106 1.60667 3.5044 1.54133 3.53106 1.48C3.55773 1.416 3.59373 1.36133 3.63906 1.316C3.6844 1.268 3.7364 1.23067 3.79506 1.204C3.8564 1.17733 3.92173 1.164 3.99106 1.164C4.0604 1.164 4.12573 1.17733 4.18706 1.204C4.25106 1.23067 4.30573 1.268 4.35106 1.316C4.39906 1.36133 4.4364 1.416 4.46306 1.48C4.4924 1.54133 4.50706 1.60667 4.50706 1.676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionalIcon);
export default __webpack_public_path__ + "static/media/institutionalIcon.fe4d52387ca97760710c7d49b598d2f9.svg";
export { ForwardRef as ReactComponent };